// Tiny handoff between a navigation source that is about to leave a view with a
// dirty bulk action (e.g. the TailorMed logo in SidebarMenu) and the single owner
// of the bulk-dirty confirmation (BulkActionNavGuard).
//
// The source registers a teardown to run ONLY if the user confirms "Discard & Leave".
// It is never run on "Stay". This keeps view-specific teardown (which the guard has
// no business knowing) out of the guard, while ensuring it runs at the right moment
// (after confirm, before the resumed push) rather than eagerly before the guard decides.
//
// Module-level (not Redux/state) on purpose: it's a transient, single-consumer baton
// read synchronously within one navigation attempt, and must not be serialized.
let pendingTeardown = null;

export const setPendingBulkLeaveTeardown = (fn) => {
  pendingTeardown = typeof fn === "function" ? fn : null;
};

// Returns the registered teardown (or null) and clears it — single-consumer.
export const takePendingBulkLeaveTeardown = () => {
  const fn = pendingTeardown;
  pendingTeardown = null;
  return fn;
};

// Second baton: when the SidebarMenu guard resolves a bulk-dirty confirmation by
// itself and then does a CROSS-ROUTE push (leaving a saved list for a bucket view),
// the global BulkActionNavGuard is also armed and would re-block that push — a second
// popup, after the selection was already cleared. The source sets this flag right
// before that push so the global guard's history.block lets that one navigation
// through instead of re-prompting. Single-shot, drained on the first block callback.
let pendingBulkNavConfirmed = false;

export const markBulkNavConfirmed = () => {
  pendingBulkNavConfirmed = true;
};

// Returns whether a cross-route push was pre-confirmed by another guard, and clears
// it — single-consumer, so only the immediately-following navigation is let through.
export const takeBulkNavConfirmed = () => {
  const confirmed = pendingBulkNavConfirmed;
  pendingBulkNavConfirmed = false;
  return confirmed;
};
